import { Separator } from "@/components/ui/separator";
const achievementsData = [{
  id: 1,
  title: "Undisputed World Champion",
  event: "WBC & WBA Unification",
  date: "NOV 2023"
}, {
  id: 2,
  title: "Fighter of the Year",
  event: "Global Boxing Association",
  date: "DEC 2022"
}, {
  id: 3,
  title: "Fastest Knockout Record",
  event: "Title Defense (0:14 R1)",
  date: "AUG 2021"
}, {
  id: 4,
  title: "Olympic Gold Medalist",
  event: "Heavyweight Division",
  date: "AUG 2016"
}, {
  id: 5,
  title: "National Amateur Champion",
  event: "Golden Gloves Tournament",
  date: "MAY 2014"
}];
export default function Achievements() {
  return <section id="achievements" className="bg-background py-24 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-16 md:gap-8 items-center">
          
          {}
          <div className="md:col-span-4 flex flex-col items-center md:items-start justify-center">
            <div className="flex flex-col items-center md:items-start">
              <div className="flex flex-col leading-[0.75] font-serif font-black text-[10rem] md:text-[14rem] text-transparent [-webkit-text-stroke:2px_var(--color-primary)] select-none">
                <span>4</span>
                <span>2</span>
              </div>
              <div className="mt-8 flex items-center gap-4">
                <div className="h-px w-12 bg-primary"></div>
                <span className="font-mono text-primary font-bold tracking-widest uppercase text-sm md:text-base">
                  Total Fights
                </span>
              </div>
            </div>
          </div>

          {}
          <div className="md:col-start-6 md:col-span-7 flex flex-col w-full">
            <Separator className="bg-border/60" />
            
            {achievementsData.map((achievement, i) => <div key={achievement.id} data-index={i} className="group relative flex flex-col">
                {}
                <div className="absolute inset-0 bg-primary/0 transition-colors duration-[400ms] ease-[cubic-bezier(0.25,1,0.5,1)] group-hover:bg-primary/5 -mx-4 px-4 sm:mx-0 sm:px-0 rounded-lg sm:rounded-none pointer-events-none" />
                
                <div className="relative flex flex-col sm:flex-row sm:items-center justify-between py-8 px-4 sm:px-6 transition-transform duration-[400ms] ease-[cubic-bezier(0.25,1,0.5,1)] group-hover:translate-x-2">
                  <div className="flex flex-col gap-2">
                    <h3 className="font-serif font-bold text-2xl md:text-3xl text-foreground tracking-wide">
                      {achievement.title}
                    </h3>
                    <div className="flex items-center gap-3 font-mono text-primary text-sm md:text-base tracking-wider">
                      <span>{achievement.event}</span>
                      <span className="w-1.5 h-1.5 rounded-full bg-primary/50" />
                      <span>{achievement.date}</span>
                    </div>
                  </div>
                </div>
                
                <Separator className="bg-border/60" />
              </div>)}
          </div>

        </div>
      </div>
    </section>;
}